import { useQuery } from "react-query";
import AlarmSetpointsDataService from "../../services/alarm-setpoints-data-service/AlarmSetpointsDataService";
import { IDisabledScheduleDTO } from "../../services/alarm-setpoints-data-service/Models";
import { RestError } from "../../services/rest-service/RestService";
import { BaseUseQueryParameters } from "../BaseUseQueryParameters";
import { keys } from "./Keys";
import { eLynxObjectTypeEnum } from "../../common/enums/eLynxObjectType";

export type UseObjectSetpointDisabledScheduleParameters = {
    groupID: number,
    objectType: eLynxObjectTypeEnum,
    objectID: number
} & BaseUseQueryParameters<IDisabledScheduleDTO>;

export function useObjectSetpointDisabledSchedule({
    groupID,
    objectType,
    objectID,
    enabled,
    onError,
    onSuccess,
    //refreshSeconds
}: UseObjectSetpointDisabledScheduleParameters) {
    return useQuery<IDisabledScheduleDTO | undefined, RestError>(
        keys.objectDisableSchedule(groupID, objectType, objectID),
        ({ signal }) => {

            return Number.isFinite(groupID) && Number.isFinite(objectType) && Number.isFinite(objectID)
                ? AlarmSetpointsDataService.getDisabledScheduleForObjectSetPoints(
                    groupID,
                    objectType,
                    objectID,
                    signal)
                : Promise.resolve(undefined);
        },
        {
            enabled,
            onError: onError,
            onSuccess: onSuccess,
            //refetchInterval: refreshSeconds ? refreshSeconds  * 1000 : false
            cacheTime: 0
        }
    );
}
